import { Box, Button, Popover } from '@mui/material';
import { useState } from 'react';
import { IconWrapper } from '../../elements/IconWrapper/Index';
import { pxToRem } from '../../../commonUtils/resizeUtils';

interface IReportButton {
  buttonText?: string;
  buttonList?: {
    name: string;
    onClick: () => void;
  }[];
}

export const ReportButton = (props: IReportButton) => {
  const { buttonText, buttonList } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const onMainButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (buttonList && buttonList?.length > 1) {
      setAnchorEl(event.currentTarget);
    } else if (buttonList && buttonList?.length === 1) {
      buttonList[0]?.onClick();
    }
  };

  return (
    <>
      <Button
        onClick={onMainButtonClick}
        sx={{
          cursor: 'pointer',
          border: '1px solid #158D29',
          borderRadius: pxToRem(10),
          color: '#0AA34F',
          display: 'flex',
          alignItems: 'center',
          gap: pxToRem(10),
        }}
      >
        <IconWrapper
          name="download"
          size="md"
          parentFolder="icons"
          type="png"
          customSx={{
            width: pxToRem(20),
            height: pxToRem(20),
          }}
        />
        {buttonText || buttonList?.[0]?.name || 'View Report'}
      </Button>
      <Popover
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPopover-paper': {
            borderRadius: pxToRem(10),
            border: '1px solid #E7E7E7',
            backgroundColor: '#FFFFFF',
          },
        }}
      >
        <Box>
          {buttonList?.map((button, index) => (
            <Box
              key={button.name}
              onClick={() => {
                button.onClick();
                setAnchorEl(null);
              }}
              sx={{
                cursor: 'pointer',
                px: pxToRem(11),
                py: pxToRem(10),
                borderBottom:
                  index === buttonList?.length - 1
                    ? undefined
                    : '1px solid #E7E7E7',
              }}
            >
              {button.name}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};
